import { Utility } from '../../../../api/properties/types';
import { useTranslation } from '@helios/frontend-core';
import UtilitySelectionWidget from '../../../UtilitySelectionWidget/UtilitySelectionWidget';

export interface UtilitySelectionStepViewProps {
  utilities: Utility[];
  isLoading: boolean;
  propertyId: string;
  onUtilitySelect: (utility: Utility) => void;
  onUtilityNotListed: () => void;
  trackingId: string;
}

export function UtilitySelectionStepView({
  utilities,
  isLoading,
  propertyId,
  onUtilitySelect,
  onUtilityNotListed,
  trackingId,
}: UtilitySelectionStepViewProps) {
  const { t } = useTranslation();

  return (
    <div className="max-w-3xl mx-auto">
      <UtilitySelectionWidget
        primaryCTA={{
          onClick: ({ utility }) => {
            if (utility) {
              onUtilitySelect(utility);
            }
          },
          children: t('common.continue'),
          trackingId: `${trackingId}-submit-button`,
        }}
        isLoading={isLoading}
        utilityNotListedOnClick={onUtilityNotListed}
        utilities={utilities}
        propertyId={propertyId}
        trackingId={trackingId}
      />
    </div>
  );
}

export default UtilitySelectionStepView;
